import React from 'react';
import { Switch, Route } from 'react-router-dom';

import IndexPage from './pages/IndexPage/IndexPage';
import AuthPage from './pages/AuthPage/AuthPage';
import FAQPage from './pages/FAQPage/FAQPage';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import AppUrlListener from './components/AppUrlListener';

const AppRouter: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <AppUrlListener />
      <Switch>
        <Route exact path="/" component={IndexPage} />
        <Route exact path="/cse-form" component={IndexPage} />
        <Route exact path="/index" component={IndexPage} />
        <Route exact path="/faq" component={FAQPage} />
        <Route exact path="/auth" component={AuthPage} />
      </Switch>
    </>
  );
};

export default AppRouter;
